import useRequest, { IEnumRecord } from '@hooks/useRequest';
import { IVendedorComissao, VendedorComissaoTipoEnum } from '@model/VendedorComissao';
import React from 'react';

export interface IVendedorComissaoFilter {
    competencia: string
}

export interface IVendedorComissaoRecord extends IVendedorComissao {
    saldo: number
}

export interface IRegistrarComisssaoRequest {
    empresaId?: number
    vendedorComissaoTipo: VendedorComissaoTipoEnum
    valor: number
    descricao: string
}

export interface IPagamentoComissaoRecibo {
    valor: number
    empresaNome: string
    empresaCnpj: string
    valorExtenso: string
    cidade: string
    dia: string
    mesExtenso: string
    ano: string
    referencia: string
}

const controller = '/VendedorComissao';

export function useVendedorComissaoService () {
    const _request = useRequest();

    const listar = React.useCallback((vendedorId: number, request: IVendedorComissaoFilter) => {
        return _request.get<IVendedorComissao[]>(`${controller}/listar/${vendedorId}`, {
            params: request
        });
    }, [_request]);

    const listarTipos = React.useCallback(() => {
        return _request.get<IEnumRecord<VendedorComissaoTipoEnum>[]>(`${controller}/listarTipos`);
    }, [_request]);

    const registrar = React.useCallback((vendedorId: number, request: IRegistrarComisssaoRequest) => {
        return _request.post<IVendedorComissao>(`${controller}/Registrar/${vendedorId}`, request);
    }, [_request]);

    const obterRecibo = React.useCallback((vendedorComissaoId: number) => {
        return _request.get<IPagamentoComissaoRecibo>(`${controller}/ObterRecibo/${vendedorComissaoId}`);
    }, [_request]);

    return React.useMemo(() => ({
        listarTipos, listar, registrar, obterRecibo
    }), [listarTipos, listar, registrar, obterRecibo]);
}